export default __webpack_public_path__ + "static/media/francisco.7e1bc0ef.png";